import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface UseRouteRedirectsProps {
  posts: Array<{ postname: string }>;
}

export const useRouteRedirects = ({ posts }: UseRouteRedirectsProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    const path = location.pathname;

    if (path.startsWith('/blog/')) {
      const postName = path.replace('/blog/', '');
      const postExists = posts.some(post => `/${post.postname}` === `'${postName}`);

      if (postExists) {
        navigate(`/${postName}`, { replace: true });
        return;
      }
    }

    const redirects: Record<string, string> = {
      '/new-search': '/search',
      '/chat-bot': '/Assistant',
      '/API': '/Tools',
    };

    const redirectTo = redirects[path];
    if (redirectTo) {
      navigate(redirectTo, { replace: true });
    }
  }, [location.pathname, navigate, posts]);
};
